import {Injectable, ElementRef, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SmartadminModule} from "../smartadmin.module";
import {SmartadminWizardsModule} from "../forms/wizards/smartadmin-wizards.module";
import {JqueryUiModule} from "../ui/jquery-ui/jquery-ui.module";
import {FormatAnswers} from "../../+tickets/ticket.service";
import {I18nPipe} from "../i18n";

@NgModule({
    imports: [
        CommonModule,
        SmartadminModule,
        SmartadminWizardsModule,
        JqueryUiModule,
    ],
    // declarations: [BasicWizardWidgetComponent, FuelUxWizardWidgetComponent]
})


@Injectable()

export class FormQuizService {
    public sections: Array<any> = [];
    public asks: Array<any> = [];
    private elRef: ElementRef;
    private formatType: string = "Script";

    constructor(private i18n: I18nPipe){

    }

    setElementRef(elRef: ElementRef) {
        this.elRef = elRef;
    }

    public sendButton:boolean = false;
    public id:number;

    /**
     * Obttiene un arreglo de objetos con el ID y el titulo de la sección
     * utiliza la clase 'section-script' para recorrer los nodos del DOM,
     * el ID lo obtiene del <header><h2>
     * **/
    getSections() {
        let sectionArray = [];
        let i = 0;
        jQuery('.section-script').each(function () {
            let id = this.id;
            let title = jQuery("#" + id + " header h2").text();
            sectionArray.push({id: this.id, title: ++i + ' - ' + title});
        });
        return sectionArray;
    }

    /**
     * Elimina el elemento del DOM  utilizando el ID
     * */
    removeAskOption(id) {
        jQuery("#" + id).remove();
    }

    /**
     * Agrega una nueva opcion a la pregunta con el ID proporcionado
     * */
    addAskOption(id, option?: any) {
        let optionId = new Date().getTime() + '-ask-option';
        let optionValue = '';
        let optionLink = '';
        if (option != undefined) {
            optionId = option.id;
            optionValue = option.value;
            if (option.show != undefined && option.show.length > 0) {
                optionLink = option.show[0];
            }
        }

        let sections = this.getSections();
        let link = jQuery("#" + id + "-link-answer").is(':checked');
        let display = link == true ? '' : 'display:none';
        let html = '<div id="' + optionId + '" class="row ask-option-input"><section style="margin:10px 0px 10px 12px;"><div class="col col-sm-4">' +
            '<label class="input">' +
            '<input class="input-sm" placeholder="'+this.i18n.transform("Add description")+'" value="' + optionValue + '" type="text" name="' + optionId + '-text">' +
            '</label>' +
            '</div>' +
            '<div class="col col-sm-3 link-answer-select" style="' + display + '"><label class="select"><select name="link-select-opt-' + optionId + '">' +
            '<option value="">'+this.i18n.transform("Next section")+'</option>';

        jQuery.each(sections, function () {
            if (optionLink != this.id)
                html += '<option value="' + this.id + '">' + this.title + '</option>';
            else
                html += '<option value="' + this.id + ' selected">' + this.title + '</option>';
        });

        html += '</select><i></i></label></div>' +
            '<div class="col col-sm-1">' +
            '<a data-id="' + optionId + '" class="remove-answer-option btn btn-default btn-circle">' +
            '<i class="glyphicon glyphicon-remove" data-id="' + optionId + '"></i></a>' +
            '</div></section></div>';
        jQuery("#" + id + "-option-list").append(html);
        jQuery('.remove-answer-option').on('click', (event) => this.removeAskOption(event.target.dataset.id));

    }

    /**
     * Muestra las posibles secciones a las que se pueden ligar las respuestas de la pregunta con el ID proporcionado
     * utiliza la clase link-answer-select para mostrar los elementos, manda a llamar updateSectionList para refrescar los cambios a los selects, por si se agrego una nueva sección
     * **/
    showSectionsList(id) {
        jQuery("#" + id + "-option-list .link-answer-select").toggle();
        this.updateSectionList();
    }

    /**
     * Actualiza la lista para las posibles secciones que se pueden ligar
     * */
    updateSectionList() {
        this.sections = this.getSections();
        let sectionsTmp = this.sections;
        let fmtType = this.formatType;

        let opt1:string = this.i18n.transform("Next section");
        let opt2:string = this.i18n.transform("Send form");
        if (fmtType == 'Script') {
            jQuery(".link-answer-select label select").each(function (index, item) {

                let value = item.value;

                let html = '<option value="next-section">'+opt1+'</option>';
                for (let i = 0; i < sectionsTmp.length; i++) {
                    html += '<option value="' + sectionsTmp[i].id + '">' + sectionsTmp[i].title + '</option>';
                }
                html += '<option value="send-form">'+opt2+'</option>';
                jQuery(item).html(html);
                jQuery(item).val(value);

            });
        }

        jQuery('.widget-footer .btn-group ul.dropdown-menu').each(function (index, item) {

            let id = jQuery(item).attr('data-id') + '-action-finish';
            let currentElements = jQuery(item).children().length;
            let value = '';
            if (currentElements > 0) {
                value = jQuery("input[name='" + id + "']:checked").val();
            }


            let linkOptions = '';
            linkOptions += '<li>' +
                '<input type="radio" id="' + id + '-next" name="' + id + '" value="next-section">' +
                '<label for="' + id + '-next">'+opt1+'</label>' +
                '</li>';
            //solo los scripts se pueden ligarcon otras secciones, la encuesta no
            if (fmtType == 'Script') {
                for (let i = 0; i < sectionsTmp.length; i++) {
                    let itemId = new Date().getTime() + "-ref-" + i;
                    linkOptions += '<li>' +
                        '<input type="radio" id="' + itemId + '" name="' + id + '" value="' + sectionsTmp[i].id + '" >' +
                        '<label for="' + itemId + '">' + sectionsTmp[i].title + '</label>' +
                        '</li>';
                }
            }
            linkOptions += '<li>' +
                '<input type="radio" id="' + id + '-send" name="' + id + '" value="send-form">' +
                '<label for="' + id + '-send">'+opt2+'</label>' +
                '</li>';

            jQuery(item).html(linkOptions);

            if (value != undefined && value != '') {

                jQuery("input[name='" + id + "']").removeAttr('checked');
                jQuery("input[name='" + id + "'][value='" + value + "']").attr('checked', 'true');
                jQuery("input[name='" + id + "'][value='" + value + "']").next().bind('click').trigger('click');

            }else{
                value = 'next-section';
                jQuery("input[name='" + id + "']").removeAttr('checked');
                jQuery("input[name='" + id + "'][value='" + value + "']").attr('checked', 'true');
                jQuery("input[name='" + id + "'][value='" + value + "']").next().bind('click').trigger('click');
            }
        });
    }

    /**
     * Verifica la configuración de la pregunta, solo los radio, select o checkbox pueden tener opciones
     * inhabilita la opcion de 'ir a seccion dependiendo de respuesta'  a través del ID
     * */
    getAskConfig(id) {
        let type = jQuery("#" + id + "-select").val();
        jQuery("#" + id + "-validation-row").remove();
        switch (type) {
            case 'radio':
            case 'select':
            case 'checkbox':
                jQuery("#" + id + "-data-type-text").remove();
                jQuery("#" + id + "-options a").show();

                if (type != 'checkbox') {
                    //permite boton para ligar con secciones
                    if (this.formatType == 'Script') {
                        jQuery("#" + id + "-link-answer").parent().removeClass('state-disabled');
                        jQuery("#" + id + "-link-answer").removeAttr('disabled');
                    }
                    //validación extra
                    jQuery("#" + id + "-validate").parent().addClass('state-disabled');
                    jQuery("#" + id + "-validate").prop('disabled', 'true');
                } else {
                    jQuery("#" + id + "-option-list .link-answer-select").hide();
                    jQuery("#" + id + "-link-answer").parent().addClass('state-disabled');
                    jQuery("#" + id + "-link-answer").prop('disabled', 'true');
                    jQuery("#" + id + "-validate").parent().removeClass('state-disabled');
                    jQuery("#" + id + "-validate").removeAttr('disabled');
                    if (jQuery("#" + id + "-validate").is(":checked")) {
                        this.getValidationHtml(id);
                    }
                }
                break;
            default:
                jQuery("#" + id + "-options a").hide();
                let dType = '';
                if (type == 'text') {
                    dType = '<div id="' + id + '-data-type-text" class="row"><section style="margin:10px 0px 10px 12px;">' +
                        '<div class="col col-sm-4">' +
                        '<label class="label">'+this.i18n.transform("Data type")+'</label>' +
                        '<label class="select"><select id="' + id + '-data-type-select" name="' + id + '-data-type-select">' +
                        '<option value="text">'+this.i18n.transform("Text")+'</option>' +
                        '<option value="integer">'+this.i18n.transform("Integer")+'</option>' +
                        '<option value="decimal">'+this.i18n.transform("Decimal number")+'</option>' +
                        '<option value="date">'+this.i18n.transform("Short Date")+'</option>' +
                        '<option value="datetime">'+this.i18n.transform("Long Date")+'</option>' +
                        '<option value="time">'+this.i18n.transform("Time")+'</option>' +
                        '<option value="email">'+this.i18n.transform("Email")+'</option>' +
                        '<option value="phone">'+this.i18n.transform("Phone")+'</option>' +
                        '</select><i></i></label>' +
                        '</div></section>'+
                    '</div>';
                }
                jQuery("#" + id + "-option-list").empty().html(dType);
                jQuery("#" + id + "-link-answer").parent().addClass('state-disabled');
                jQuery("#" + id + "-link-answer").prop('disabled', 'true');
                jQuery("#" + id + "-validate").parent().removeClass('state-disabled');
                jQuery("#" + id + "-validate").removeAttr('disabled');
                if (jQuery("#" + id + "-validate").is(":checked")) {
                    this.getValidationHtml(id);
                }
                break;

        }
    }

    /**
     Elimina una pregunta del contenedor
     */
    deleteAskFromSection(id) {
        jQuery("#" + id).remove();
    }

    /**
     Agrega funcionalidades para eliminar pregunta, ligar respuestas y hacer el input como requerido
     */
    getFooter(id, type,ask?:any) {
        let html = `<div class="col col-sm-12 text-right">
            <a data-id="${id}" class="ask-footer-config" data-type="title" class="btn btn-default txt-color-red">
            <i data-action="delete" data-id="${id}" class="fa fa-trash-o fa-lg"></i></a> `;
        let checked = '';
        if(ask && ask.dataValidation && ask.dataValidation.required)
            checked = `checked="checked"`;
        if (type == 'ask') {
            let linkAnswerId = id + '-link-answer';
            let stateDisabled = '';
            let disabled = '';
            if (this.formatType == 'Encuesta') {//se deshabilita para encuestas
                stateDisabled = 'state-disabled';
                disabled = 'disabled';
            }
            html += '<label class="toggle" style="display:inline;">' +
                '<input class="ask-footer-config" name="' + id + '-required" id="' + id + '-required" data-action="required" data-id="' + id + '" '+checked+' type="checkbox">' +
                '<i data-swchon-text="'+this.i18n.transform("Yes")+'" data-swchoff-text="NO"></i>' +
                'Requerido' +
                '</label>&nbsp;' +
                '<label class="toggle state-disabled" style="display:inline;">' +
                '<input class="ask-footer-config" disabled="disabled" name="' + id + '-validate" id="' + id + '-validate" type="checkbox" data-action="validate" data-id="' + id + '" >' +
                '<i data-swchon-text="'+this.i18n.transform("Yes")+'" data-swchoff-text="NO"></i>' +
                'Validar' +
                '</label>' +
                '&nbsp;<label class="inline toggle ' + stateDisabled + '" style="display:inline;">' +
                '<input class="ask-footer-config" name="' + linkAnswerId + '" id="' + linkAnswerId + '" data-action="link-answer" data-id="' + id + '"  type="checkbox" ' + disabled + '>' +
                '<i data-swchon-text="'+this.i18n.transform("Yes")+'" data-swchoff-text="NO"></i>' +
                this.i18n.transform('Link answer to section') +
                '</label>&nbsp;';

        }
        html += '</div>';
        return html;

    }

    /**
     * Mostrar formas para validación de campo
     * */
    getValidationHtml(id) {
        let type = jQuery("#" + id + "-select").val();
        let idValidation = id + "-validation-row";
        let html = '<div class="col col-sm-12" id="' + idValidation + '"><div class="row">';
        if (type == 'checkbox') {
            html += '<div class="col col-sm-6">' +
                '<label class="label">'+this.i18n.transform('Link answer to section')+'</label>' +
                '<label class="select">' +
                '<select name="' + idValidation + '-select" id="' + idValidation + '-select">' +
                '<option value="min">'+this.i18n.transform('Select al least')+'</option>' +
                '<option value="max">'+this.i18n.transform('Select a max of')+'</option>' +
                '<option value="equals">'+this.i18n.transform('Select exactly')+'</option>' +
                '</select>' +
                '</label>' +
                '</div>' +
                '<div class="col col-sm-6">' +
                '<label class="label">'+this.i18n.transform('Options to select')+'</label>' +
                '<label class="input">' +
                '<input type="number" id="' + idValidation + '-value" name="' + idValidation + '-value" placeholder="1"/>' +
                '</label>' +
                '</div>';
        } else {
            html += '<div class="col col-sm-6">' +
                '<label class="label">'+this.i18n.transform('Add regex to validation')+'</label>' +
                '<label class="input">' +
                '<input type="text" name="' + idValidation + '-value" id="' + idValidation + '-value" placeholder="[0-9]{5}"/>' +
                '</label>' +
                '</div>' +
                '<div class="col col-sm-6">' +
                '<label class="label">'+this.i18n.transform('Validation message')+'</label>' +
                '<label class="input">' +
                '<input type="text" id="' + idValidation + '-message" name="' + idValidation + '-message"/>' +
                '</label>' +
                '</div>';
        }
        html += '</div></div>';
        if (jQuery("#" + id + "-validate").is(":checked")) {
            jQuery(html).insertAfter(jQuery("#" + id + "-options"));
        } else {
            jQuery("#" + idValidation).remove();
        }
    }

    /**
     * Agrega una nueva pregunta al contenedor
     */
    addAskToSection(type, id, ask?: any) {
        let askId = new Date().getTime() + "-" + type;
        let askValue = '';
        let askTitle = '';
        let askDescription = '';
        if (ask != undefined) {
            askId = ask.id;
            askValue = ask.label;
            askTitle = ask.title != undefined ? ask.title : '';
            askDescription = ask.description != undefined ? ask.description : '';
        }
        let html = '<div class="row smart-form ask-item" id="' + askId + '">';
        if (type == 'ask') {
            //pregunta
            html += '<div class="col col-sm-6">';
            html += '<section><label class="input">' +
                '<i class="icon-append fa fa-question-circle"></i>' +
                '<input class="input-ask" name="input-ask-legend' + askId + '" value="' + askValue + '" placeholder="'+this.i18n.transform('Ask')+'" type="text">' +
                '<b class="tooltip tooltip-top-right">' +
                '<i class="fa fa-warning txt-color-teal"></i>' +
                this.i18n.transform('Add ask description')+'</b>' +
                '</label></section>';
            html += '</div>';
            //configuraciontarget
            html += '<div class="col col-sm-6">' +
                '<section>' +
                '<label class="select" >' +
                '<select class="input-type" id="' + askId + '-select" name="' + askId + '-select" data-id="' + askId + '">' +
                '<option value="radio">'+this.i18n.transform('Select (radius)')+'</option>' +
                '<option value="checkbox">'+this.i18n.transform('Verification checkbox')+'</option>' +
                '<option value="select">'+this.i18n.transform('Dropdown list')+'</option>' +
                '<option value="text">'+this.i18n.transform('Text')+'</option>' +
                '<option value="textarea">'+this.i18n.transform('Multiline text')+'</option>' +
                '</select><i></i>' +
                '</label>' +
                '<section>' +
                '</div>';
            html += '<div class="col col-sm-12" id="' + askId + '-options">' +
                '<a  data-id="' + askId + '" class="opcionButton btn btn-labeled btn-primary">' +
                '<span style="left: 0px" class="btn-label"><i class="fa fa-plus "></i></span></i>'+this.i18n.transform('Add option')+'</a>' +
                '<div class="row" id="' + askId + '-option-list" class="option-list">' +
                '</div>' +
                '</div>';
        } else {
            html += '<div class="col col-sm-12">' +
                '<section>' +
                '<label class="textarea">' +
                '<textarea class="title" name="title-ask-' + askId + '" placeholder="'+this.i18n.transform('Add tittle')+'">' + askTitle + '</textarea>' +
                '</label>' +
                '</section>' +
                '<section>' +
                '<label class="textarea">' +
                '<textarea class="input-xs description" name="title-description-' + askId + '" type="text" placeholder="'+this.i18n.transform('Add description')+'">' + askDescription + '</textarea>' +
                '</label>' +
                '<section>' +
                '<div>';
        }

        html += this.getFooter(askId, type,ask);
        html += '</div>';
        jQuery("#" + id + " div.widget-body div.ul-asks").append(html);
        //aqui los elementos ya estan en el DOM
        jQuery('.ask-footer-config').unbind('click').on('click', (event) => {
            let action = event.target.dataset.action;
            if (action == 'validate') {
                this.getValidationHtml(event.target.dataset.id);
            } else if (action == 'link-answer') {
                this.showSectionsList(event.target.dataset.id);
            } else if (action == 'delete')
                this.deleteAskFromSection(event.target.dataset.id);
        });
        jQuery('.opcionButton').unbind('click').on('click', (event) => this.addAskOption(event.target.dataset.id));
        jQuery('.input-type').unbind('change').on('change', (event) => this.getAskConfig(event.target.dataset.id));
        try {
            jQuery("#" + id + " div.widget-body div.ul-asks").sortable({
                items: jQuery('.ul-asks').find('.ask-item'),
                connectWith: "#" + id + " div.widget-body div.ul-asks",
                cursor: 'move',
                revert: true,
                opacity: 1,
                delay: 150,
                reverDuration: 0
            });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * Obtiene el html para la nueva sección que se esta generando
     * */
    getNewSection(id, pos, section) {
        let title = this.i18n.transform("Title");
        let description = '';
        if (section != undefined) {
            title = section.title;
            description = section.description != undefined ? section.description : '';
        }

        let next = '';
        if(section && section.next ){
            next = section.next
        }

        let html = '<div class="jarviswidget section-script" id="' + id + '" data-widget-togglebutton="true"   data-widget-colorbutton="true" data-widget-fullscreenbutton="true">' +
            '<header>' +
            '<h2><strong>' + this.i18n.transform("Title") + '</strong> <i></i></h2><h3>' +
            '<div class="widget-toolbar" role="menu" style="margin-top:-19px;">' +
            '<div class="btn-group">' +
            '<button class="btn dropdown-toggle btn-xs btn-primary" data-toggle="dropdown">' +
            this.i18n.transform("Options")+ '<i class="fa fa-caret-down"></i>' +
            '</button>' +
            '<ul class="dropdown-menu pull-right">' +
            '<li><a class="add-ask-button" data-type="ask" data-id="' + id + '">'+this.i18n.transform("Add question")+'</a></li>' +
            '<li><a class="add-ask-button" data-type="title" data-id="' + id + '">'+this.i18n.transform("Add tittle or description")+'</a></li>' +
            '<li><a class="add-section-button" data-type="section" data-id="' + id + '">'+this.i18n.transform("Add section")+'</a></li>' +
            '</ul>' +
            '</div>' +
            '</div>' +
            '<div>' +
            '</header>' +
            '<div class="jarviswidget-editbox">' +
            '<textarea class="form-control" type="text"></textarea>' +
            '<span class="note"><i class="fa fa-check text-success"></i>'+this.i18n.transform("Update") +
            this.i18n.transform("Script title")+'!</span>' +
            '</div>' +
            '<div class="widget-body"><section class="smart-form"><label class="textarea"><textarea class="input-xs" type="text" name="section-desc-xs-' + id + '" placeholder="Descripción de seccion - opcional">' + description + '</textarea></label></section><div sm-sortable class="todo ui-sortable ul-asks"></div>' +
            '</div><div class="widget-footer">' +
            '<div class="badge bg-color-greenLight">' +
            this.i18n.transform("Section")+':' + pos +
            '</div>' +
            this.i18n.transform("Next section")+':<div class="btn-group" style="padding-bottom:5px;padding-left:10px;">' +
            '<button data-toggle="dropdown" class="btn btn-xs btn-success dropdown-toggle">' +
            '<span class="caret"></span></button>' +
            '<ul class="dropdown-menu pull-right" data-id="' + id + '">' +
            '</ul>' +
            '</div>' +
            '</div>' +
            '</div>'
        '</div>';
        return html;
    }

    /**
     * Agrega una nueva seccion al DOM
     * **/
    addSection(section?: any) {
        if (section == undefined)
            var id = new Date().getTime();
        else
            id = section.id;
        this.sections.push(id);
        let html = this.getNewSection(id, this.sections.length, section);
        jQuery('#sections-article').append(html);
        try {
            jQuery("#sections-article").jarvisWidgets('destroy');
        } catch (e) {
        }
        jQuery("#sections-article").jarvisWidgets({
            labelDelete: this.i18n.transform("Do you want to delete section"),
            onDelete: this.deleteAction,
            onEdit: this.editAction,
            serviceReference: this
        }).init();
        this.updateSectionList();
        jQuery('.add-ask-button').unbind('click').on('click', (event) => this.addAskToSection(event.target.dataset.type, event.target.dataset.id));
        jQuery('.add-section-button').unbind('click').on('click', (event) => this.addSection());

    }

    /**
     * Se dispara cuando se elimina una sección del DOM
     * */
    deleteAction(event) {
        this.updateSectionList();
    }

    /**
     * Se actualiza el nombre de la sección en las listas
     * */
    editAction(elem, widget) {
        let btn = elem.context.firstElementChild.className;
        if (btn == 'fa fa-cog') {
            this.updateSectionList();
        }
    }

    /**
     * Obtiene las configuraciones de cada seccion y las agrega a un arreglo
     * */
    getSectionsArray() {

        let jsonFormat = [];
        jQuery('.section-script').each(function () {

            let sectionId = this.id;
            let section = {
                title: jQuery("#" + sectionId + " header h2").text(),
                description: jQuery("textarea[name='section-desc-xs-" + sectionId + "']").val(),
                id: sectionId,
                asks: [],
                next: {}
            };

            jQuery("#" + sectionId + " .ask-item").each(function () {
                let ask = {
                    id: this.id,
                    type: this.type,
                    description: this.description,
                    title: this.title,
                    parent: this.parent,
                    values: this.values,
                    dataValidation: {
                        required: this.requried,
                        hasValidation: false,
                        validationType: '',
                        validationValue: '',
                        validationMessage: ''
                    },
                    label: '',
                    dataType: 'text',
                };

                if (ask.id.indexOf('ask') == -1) {
                    ask.type = 'label';
                    ask.description = jQuery("#" + ask.id + " textarea.description").val();
                    ask.title = jQuery("#" + ask.id + " textarea.title").val();
                    ask.parent = false;
                    ask.values = [];
                    ask.dataValidation.required = true;
                    ask.dataValidation.hasValidation = false;
                } else {
                    //obtener configuraciones
                    ask.type = jQuery("#" + ask.id + " .input-type").val();
                    ask.label = jQuery("#" + ask.id + " .input-ask").val();
                    ask.parent = true;
                    ask.dataValidation.required = jQuery("#" + ask.id + "-required").is(":checked");
                    ask.dataValidation.hasValidation = jQuery("#" + ask.id + "-validate").is(":checked");//validaciones extra
                    if (ask.dataValidation.hasValidation == undefined)
                        ask.dataValidation.hasValidation = false;
                    if (ask.type != 'text' && ask.type != 'textarea') {
                        ask.parent = jQuery("#" + ask.id + "-link-answer").is(":checked");
                        ask.values = [];
                        //opciones y linksis XD
                        jQuery("#" + ask.id + "-option-list .ask-option-input").each(function () {
                            let divId = this.id;
                            let value = {
                                label: jQuery("#" + divId + " input").val(),
                                value: jQuery("#" + divId + " input").val(),
                                id: divId,
                                show: {}
                            };
                            //cuando se seleccione esta respuesta, enviar a siguiente seccion, seccion elegida o enviar formulario
                            if (ask.parent) {
                                value.show = [jQuery("#" + divId + " .link-answer-select select").val()];
                            }
                            ask.values.push(value);
                        });
                    } else if (ask.type == 'text') {
                        ask.dataType = jQuery("#" + ask.id + "-data-type-select").val();
                    }
                    if (ask.dataValidation.hasValidation) {
                        if (ask.type == 'checkbox') {
                            ask.dataValidation.validationType = jQuery("#" + ask.id + "-validation-row-select").val();
                            ask.dataValidation.validationValue = jQuery("#" + ask.id + "-validation-row-value").val();
                        } else {
                            ask.dataValidation.validationType = 'regex';
                            ask.dataValidation.validationValue = jQuery("#" + ask.id + "-validation-row-value").val();
                            ask.dataValidation.validationMessage = jQuery("#" + ask.id + "-validation-row-message").val();
                        }
                    }
                }
                //reference from ulvalidation-row-value

                section.asks.push(ask);
            });
            //siguiente sección
            section.next = jQuery("input[name='" + sectionId + "-action-finish']:checked").val();
            jsonFormat.push(section);
        });
        return jsonFormat;
    }

    /**
     * Visualizacion de script
     * **/
    public scriptAnswers: Array<any> = [];
    public it: 0;
    public finished: boolean = false;

    /**
     * Visualiza el nodo dentro del wizard
     * */
    getHtmlNode(node) {
        let html = '';
        //let required = node.dataValidation.required;
        let required = '';


        if (node.dataValidation.required)
            required = 'required';
        let hasValidation = node.dataValidation.hasValidation;
        let validationType = node.dataValidation.validationType;
        let validationValue = node.dataValidation.validationValue;
        let validationMessage = node.dataValidation.validationMessage;



        switch (node.type) {
            case 'radio':
                html += '<div class="row ask-script-section" ' + 'data-validation-value="' + validationValue + '"' +
                    ' data-validation-type="' + validationType + '"' +
                    ' data-validation="' + hasValidation + '" data-label="' + node.label + '"' +
                    ' data-type="' + node.type + '" data-id="' + node.id + '">' +
                    '<div class="col col-xs-12 col-sm-12"><label class="label">' + node.label + '</label>';
                for (let i = 0; i < node.values.length; i++) {
                    html += '<label class="radio" '+ required + '>';
                    html += '<input '+ required + ' type="radio" name="' + node.id + '"' +
                        ' id="' + node.values[i].id + '" data-show="' + node.values[i].show + '"' +
                        ' value="' + node.values[i].value + '"/>';
                    html += '<i></i>' + node.values[i].label + '</label>';
                }
                html += '</div></div>';
                break;
            case 'checkbox':
                html += '<div class="row ask-script-section" data-validation-value="' + validationValue + '"' +
                    ' data-validation-type="' + validationType + '" data-validation="' + hasValidation + '"' +
                    ' data-label="' + node.label + '" data-type="' + node.type + '" data-id="' + node.id + '">' +
                    '<div class="col col-xs-12 col-sm-12"><label class="label">' + node.label + '</label>';
                for (let i = 0; i < node.values.length; i++) {
                    html += '<label class="checkbox">';
                    html += '<input ' + required + ' type="checkbox" name="' + node.id + '"' +
                        ' id="' + node.values[i].id + '" data-show="' + node.values[i].show + '"' +
                        ' value="' + node.values[i].value + '"/>';
                    html += '<i></i>' + node.values[i].label + '</label>';
                }
                html += '</div></div>';
                break;
            case 'select':
                html += '<div class="row ask-script-section" data-validation-value="' + validationValue + '"' +
                    ' data-validation-type="' + validationType + '" data-validation="' + hasValidation + '"' +
                    ' data-label="' + node.label + '" data-type="' + node.type + '" data-id="' + node.id + '">' +
                    '<div class="col col-xs-12 col-sm-12"><label class="label">' + node.label + '</label>';
                html += '<label class="select"><select data-parent="' + parent + '" ' + required + ' ' +
                    ' name="' + node.id + '" id="' + node.id + '">';
                html += '<option value="">'+this.i18n.transform("Select option")+'</option>';
                for (let i = 0; i < node.values.length; i++) {
                    html += '<option data-show="' + node.values[i].show + '"' +
                        ' value="' + node.values[i].value + '">' + node.values[i].label + '</option>';
                }
                html += '</select><i></i></label>';
                html += '</div></div>';
                break;
            case 'text':
                html += '<div class="row ask-script-section" data-validation-value="' + validationValue + '"' +
                    ' data-validation-type="' + validationType + '" data-validation="' + hasValidation + '"' +
                    ' data-label="' + node.label + '" data-type="' + node.type + '" data-id="' + node.id + '">' +
                    '<div class="col col-xs-12 col-sm-12"><label class="label">' + node.label + '</label>';
                html += '<label class="input"><input type="text" ' + required + ' name="' + node.id + '"' +
                    ' id="' + node.id + '"></label>';
                html += '</div></div>';
                break;
            case 'textarea':
                html += '<div class="row ask-script-section" data-validation-value="' + validationValue + '"' +
                    ' data-validation-type="' + validationType + '" data-validation="' + hasValidation + '"' +
                    ' data-label="' + node.label + '" data-type="' + node.type + '" data-id="' + node.id + '">' +
                    '<div class="col col-xs-12 col-sm-12"><label class="label">' + node.label + '</label>';
                html += '<label class="textarea"><textarea type="text" ' + required + ' name="' + node.id + '"' +
                    ' id="' + node.id + '" rows="5"></textarea></label>';
                html += '</div></div>';
                break;
            case 'label':
                if (node.title != undefined && node.title != '') {
                    html += '<div class="row paragraph-description">' +
                        '<div class="col col-xs-12 col-sm-12"><h5>' + node.title + '</h5></div></div>';
                }
                if (node.description != undefined && node.description != '') {
                    html += '<div class="row paragraph-description">' +
                        '<div class="col col-xs-12 col-sm-12"><h5><h6>' + node.description + '</h6></div></div>';
                }
                break;
        }

        return html;
    }

    /**
     * Agrega la navegación al wizard
     * */
    getStep(node, step) {
        let sectionId = node.id;
        let html = '<li style="width: 100%" id="nav-' + sectionId + '" data-target="#step' + (step) + '" data-id="' + sectionId + '">' +
            '<a href="#' + sectionId + '" data-toggle="tab">' +
            '<span class="step"><i class="fa fa-circle-o"></i></span>' +
            '<span class="title paragraph-description">' + node.title + '</span>' +
            '</a>' +
            '</li>';
        jQuery(".form-wizard").append(html);

        let pane = '<div class="tab-pane" id="' + sectionId + '">' +
            '<br>';
        if (node.description != undefined && node.description != '')
            pane += '<div class="row"><div class="col col-xs-12 col-sm-12"><h3 class="paragraph-description"><strong>' + node.description + '</strong></h3></div></div>';

        node.asks.forEach(n => {
            pane += this.getHtmlNode(n);
        });
        pane += '</div>';
        jQuery(pane).insertBefore('.tab-content .form-actions');
    }

    onNext(tab, navigation, index) {
        let jQueryvalid = jQuery("#wizard-1").valid();
        let li = jQuery('#bootstrap-wizard-1').find("li[data-target*='#step" + (index) + "']");
        let sectionId = tab[0].dataset.id;
        if (!jQueryvalid || !this.customValidation(sectionId)) {
            return false;
        } else {
            let node = this.findNode(sectionId, 'id', this.asks);
            let referenceId = this.findSectionReference(node.asks);
            let idx = this.findIndexReference(referenceId, 'id', this.asks);
            //ver preguntas capturadas
            this.getAnswers(sectionId);
            if (node.next != 'send-form') {
                if (referenceId != 'next-section' && idx != -1) {
                    this.completeStep(index);
                    jQuery("#nav-" + referenceId).attr('data-from', sectionId);
                    this.showStep(index, idx);
                    return true;
                } else {
                    if (node.next != undefined) {
                        idx = this.findIndexReference(node.next, 'id', this.asks);
                        if (node.next != 'next-section') {
                            jQuery("#nav-" + node.next).attr('data-from', sectionId);
                            this.showStep(index, idx);
                            return true;
                        } else if (node.next == 'next-section') {
                            let currentIndex = this.findIndexReference(node.id, 'id', this.asks);
                            jQuery("#nav-" + this.asks[currentIndex + 1].id).attr('data-from', sectionId);
                            this.showStep(index, index);
                            return true;
                        } else {
                            this.finished = true;
                            let sendButton = '<button type="button" id="btn-submit" class="btn btn-primary">'+this.i18n.transform("Save")+'</button>';
                            jQuery("#nav-finish-form").attr('data-from', sectionId);
                            jQuery(".pager li.next").hide();
                            jQuery(".pager li").append(sendButton);
                            this.showStep(index, this.asks.length - 1);//envia al final de la encuesta
                            return true;
                        }
                    }
                }
            } else {
                this.finished = true;
                jQuery("#nav-finish-form").attr('data-from', sectionId);
                jQuery(".pager li.next").hide();
                this.showStep(index, this.asks.length - 1);//envia al final de la encuesta
                this.completeStep(index);
                this.sendButton = true;
                return true;
            }
            return false;
        }
    }

    onPrevious(tab, navigation, index) {
        let answersTemp = this.scriptAnswers;

        if (index != -1) {
            //esconder por si se selecciona otro dato
            this.sendButton = false;
            let sectionId = tab[0].dataset.id;
            let dataFrom = tab[0].dataset.from;
            jQuery(".pager li.next").show();
            this.finished = false;
            let idx = this.findIndexReference(sectionId, 'id', this.asks);
            jQuery('#bootstrap-wizard-1').bootstrapWizard('hide', idx);
            jQuery('#btn-submit').remove();
            jQuery("#" + sectionId + " div.ask-script-section").each(function (index, item) {
                var deleteAnswer = item.dataset.id;
                this.scriptAnswers = answersTemp.filter((obj) => {
                    return obj.askId != deleteAnswer;
                });
            });
            if (dataFrom != undefined) {
                jQuery('#bootstrap-wizard-1').bootstrapWizard('display', this.findIndexReference(dataFrom, 'id', this.asks));
                jQuery('#bootstrap-wizard-1').bootstrapWizard('show', this.findIndexReference(dataFrom, 'id', this.asks));
                return true;
            }
            return false;
        }
        return false;
    }

    fueluxWizard() {
        jQuery("#bootstrap-wizard-1").bootstrapWizard({
            'withVisible': false,
            'tabClass': 'form-wizard',
            'onInit': function (tab, navigation, index) {
            },
            'onTab': function (tab, navigation, index) {
                return false;
            },
            'service': this
        });
        //solo mostrar la sección 1
        for (let i = 0; i < this.asks.length; i++) {
            if (i > 0) {
                jQuery('#bootstrap-wizard-1').bootstrapWizard('hide', i);
            }
        }
    }



    customValidation(sectionId) {
        let patternCode:string = this.i18n.transform("Text does not belong to selected pattern");
        let valmsg1:string = this.i18n.transform("Select at least");
        let valmsg2:string = this.i18n.transform("List´s option");
        let valmsg3:string = this.i18n.transform("Cannot select more than");
        let valmsg4:string = this.i18n.transform("Must select");
        let valid = true;
        jQuery("#" + sectionId + " .ask-script-section").each(function () {
            let validation = jQuery(this).attr('data-validation');
            let validationType = jQuery(this).attr('data-validation-type');
            let validationValue = jQuery(this).attr('data-validation-value');
            if (validation != undefined && validation != '' && validationType != undefined && validationType != '' && validationValue != undefined && validationValue != '') {
                //validar
                let type = this.dataset.type;
                let id = this.dataset.id;
                switch (type) {
                    case 'text':
                    case 'textarea':
                        if (validationType != undefined && validationType != '' && validationValue != undefined && validationValue != '') {
                            let value = jQuery("#" + id).val() + '';
                            valid = new RegExp(validationValue).test(value);
                            if (!valid) {
                                jQuery(this).append('<em class="txt-color-red">'+patternCode+'</em>');
                            }
                            return valid;
                        }
                        break;
                    case 'checkbox':
                        let count = 0;
                        jQuery('input[name="' + id + '"]:checked').each(function () {
                            count++;
                        });
                        let valMsg = '';
                        if (validationType == 'min') {
                            valid = count >= parseInt(validationValue);
                            valMsg = valmsg1+': ' + validationValue + " -"+valmsg2;
                        } else if (validationType == 'max') {
                            valid = count <= parseInt(validationValue);
                            valMsg = valmsg3+': ' + validationValue + " -"+valmsg2;
                        } else {
                            valid = count == parseInt(validationValue);
                            valMsg = valmsg4+': ' + validationValue + " -"+valmsg2;
                        }
                        if (!valid) {
                            jQuery(this).append('<em class="txt-color-red">' + valMsg + '</em>');
                        }
                        return valid;
                }
            }
        });
        return valid;
    }

    resetScript() {
        this.scriptAnswers = [];
        this.finished = false;
        jQuery('#bootstrap-wizard-1').bootstrapWizard('first');
    }

    getAnswers(sectionId) {
        jQuery("#" + sectionId + " .ask-script-section").each((index, item) => {
            let answer:FormatAnswers = {
                key: item.key,
                valueText: item.value,
                askId: item.askId
            };
            let type = item.dataset.type;
            let id = item.dataset.id;
            switch (type) {
                case 'text':
                case 'textarea':
                case 'select':
                    answer.key = item.dataset.label;
                    answer.valueText = jQuery("#" + id).val();
                    answer.askId = id;
                    break;
                case 'radio':
                    answer.key = item.dataset.label;
                    answer.valueText = jQuery("input[name='" + id + "']:checked").val();
                    answer.askId = id;
                    break;
                case 'checkbox':
                    answer.key = item.dataset.label;
                    answer.askId = id;
                    answer.valueText = "";
                    jQuery('input[name="' + id + '"]:checked').each(function () {
                        answer.valueText += this.value + '|';
                    });
                    break;
            }
            let idx = this.findIndexReference(id, 'askId', this.scriptAnswers);
            if (idx == -1)
                this.scriptAnswers.push(answer);
            else
                this.scriptAnswers[idx].valueText = answer.valueText;//reemplazar valor
        });
    }

    showStep(indexComplete, indexShow) {
        this.completeStep(indexComplete);
        //solo mostrar el actual
        if (indexShow != -1) {
            for (let i = 0; i < this.asks.length; i++) {
                if (i == indexShow) {
                    jQuery('#bootstrap-wizard-1').bootstrapWizard('display', indexShow);
                    jQuery('#bootstrap-wizard-1').bootstrapWizard('show', indexShow);
                } else {
                    jQuery('#bootstrap-wizard-1').bootstrapWizard('hide', i);
                }
            }
        }
    }

    completeStep(index) {
        jQuery('#bootstrap-wizard-1').find('.form-wizard').children('li').eq(index - 1).addClass('complete');
        jQuery('#bootstrap-wizard-1').find('.form-wizard').children('li').eq(index - 1).find('.step').html('<i class="fa fa-check"></i>');
    }


    findNode(nodeId, attr, nodes) {
        return nodes.find(function (value, index) {
            return value[attr] == nodeId;
        });
    }

    findIndexReference(nodeId, attr, nodes) {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i][attr] == nodeId) {
                return i;
            }
        }
        return -1;
    }

    findSectionReference(asks) {
        let referenceId = '';
        jQuery.each(asks, function () {
            switch (this.type) {
                case 'radio':
                case 'select':
                    let value = '';
                    if (this.type == 'select') {
                        value = jQuery("#" + this.id).val();
                    } else {
                        value = jQuery("input[name='" + this.id + "']:checked").val();
                    }
                    //solo con estos elementos se peuede hacer referencias a otra sección
                    jQuery.each(this.values, function () {
                        if (this.show != undefined && this.value == value) {
                            referenceId = this.show[0];
                        }
                    });
                    break;
            }
        });
        return referenceId;
    }

    changeFormatType(value: string) {
        let previousType = this.formatType;
        this.formatType = value;
        //TODO verificar si se deben eliminar los links de las preguntas debido a que las encuestas no deben llevar ligas entre preguntas y secciones
        let sections = this.getSectionsArray();
        if (sections.length > 0) {
            this.updateSectionList();
        }
    }

    setArray() {
        let preview: any = this.getSectionsArray();
        localStorage.setItem('preview', JSON.stringify(preview));
        this.asks = this.getSectionsArray();
    }

    public returnPreview: any = localStorage.getItem('preview');
}

